//表演场地上传
import { Card, Form, Input, Button, Space, Image, Upload, Spin, message, Select, Modal } from "antd";
import { PlusOutlined, } from '@ant-design/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { uploadFileByBatchAPI } from '@/apis/file'
import { checkShowLocationAPI, uploadShowLocationAPI } from '@/apis/showLocation'

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import MapComponent from "@/utils/Map";

const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});

const handleFileChange = (e) => {
    if (Array.isArray(e)) {
        return e;
    }
    return e && e.fileList;
}

const layout = {
    labelCol: {
        span: 6,
        style: {
            whiteSpace: 'normal',
            lineHeight: '1.4',
            textAlign: 'right',
            fontWeight: '500',
            paddingRight: '12px',
        }
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const ShowLocationUpload = () => {
    const { t } = useTranslation();

    const currUserId = useSelector(state => state.user.userInfo.userId)

    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([])

    const buttonString1 = t("ButtonList.UploadTakeOffArea")
    const buttonString2 = t("ButtonList.UploadWatchingArea")
    const buttonString3 = t("ButtonList.UploadRendering")

    const location = useLocation();
    const center = location.state?.center || { lat: 0, lon: 0 };

    const GeomagneticDetectionSelection = [
        { value: 0, label: t("GeomagneticDetectionSelection.NoInterference") },
        { value: 1, label: t("GeomagneticDetectionSelection.LowInterference") },
        { value: 2, label: t("GeomagneticDetectionSelection.MediumInterference") },
        { value: 3, label: t("GeomagneticDetectionSelection.HighInterference") }
    ]

    const windLevelCol = [
        { label: '无风', value: 0 },
        { label: '一级风', value: 1 },
        { label: '二级风', value: 2 },
        { label: '三级风', value: 3 },
        { label: '四级风', value: 4 },
        { label: '五级风及以上', value: 5 },
    ];

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };
    const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
    const uploadTakeOffAreaButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                {fileList.length === 0 ? buttonString1 : null}
                {fileList.length === 1 ? buttonString2 : null}
                {fileList.length === 2 ? buttonString3 : null}
            </div>
        </button>
    );

    //通过接口上传文件
    async function uploadFileByBatchByAPI(fileList) {
        const formData = new FormData()
        fileList.forEach((file) => {
            formData.append('files', file.originFileObj, file.name);
        });
        try {
            let res = await uploadFileByBatchAPI(formData)
            return res
        } catch (error) {
            console.error("Error uploading files:", error);
            throw error;
        }
    }

    //通过接口上传场地信息
    async function uploadShowLocationByAPI(showLocation) {
        try {
            let res = await uploadShowLocationAPI(showLocation)
            return res
        } catch (error) {
            console.error("Error uploading show location:", error);
            throw error;
        }
    }

    //通过接口上传查询当前场地是否已存
    async function checkShowLocationByAPI(showLocationName) {
        try {
            let res = await checkShowLocationAPI(showLocationName)
            return res
        } catch (error) {
            console.error("Error checking show location:", error);
            throw error;
        }
    }

    const onFinish = async (values) => {

        setLoading(true);
        // 发起上传请求
        let ifSLExist = (await checkShowLocationByAPI(values.placeName))

        if (ifSLExist.code === 406) {
            messageApi.error(ifSLExist.msg);
            setLoading(false);
        } else {
            try {
                let res = await handleFilesUpload(fileList);
                if (res.code === 0) {
                    // 上传成功，将返回图片ID设置到上传表单
                    const fileIdList = res.data
                    const str = fileIdList.join(','); // 将数组元素拼接成一个字符串
                    const updateFile = {
                        ...values,
                        photoList: str,
                        userId: currUserId
                    }
                    try {
                        let res1 = await uploadShowLocationByAPI(updateFile)
                        if (res1.code === 0) {
                            // 上传成功
                            form.resetFields();
                            messageApi.success(t('Message.ShowLocationUploadSuccess'));
                            // window.location.reload()
                        } else {
                            messageApi.error(t('Message.ShowLocationUploadFail') + res1.msg);
                        }
                    } catch (e) {
                        messageApi.error(t('Message.ShowLocationUploadFail') + e.msg);
                    }
                } else {
                    messageApi.error(t('Message.PictureUploadFail') + res.msg);
                }
            } catch (e) {
                messageApi.error(t('Message.PictureUploadFail') + e.msg);
            }
            // console.log("photoStringList :", photoStringList);
        }
    };

    const onReset = () => {
        form.resetFields();
        setFileList([]);
    };

    const beforeUpload = (file) => {
        // 文件上传前的校验逻辑
        // 校检文件类型
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            messageApi.error('只能上传 JPG 或 PNG 格式的图片！');
            return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            messageApi.error('图片大小不能超过 2MB！');
            return false;
        }
        return false; // 阻止自动上传，由手动上传控制
    }
    const props = {
        name: 'file',
        action: 'http://localhost:8080/upload',
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                console.log(`${info.file.name}  文件上传成功`);
            } else if (info.file.status === 'error') {
                console.log(`${info.file.name}  文件上传失败`);
            }
        },
        onRemove: file => {
            // 删除文件的逻辑...
        },
        multiple: true,
    };

    const handleFilesUpload = async (files) => {
        if (!files || files.length < 3) {
            messageApi.error('请至少上传 3 张图片');
            setLoading(false);
            return;
        }

        // 验证文件格式
        const invalidFiles = files.filter(file => {
            const fileType = file.type || file.originFileObj?.type;
            return fileType !== 'image/jpeg' && fileType !== 'image/png';
        });

        if (invalidFiles.length > 0) {
            messageApi.error('只能上传 JPG 或 PNG 格式的图片！');
            setLoading(false);
            return;
        }

        // 验证文件大小
        const oversizedFiles = files.filter(file => {
            const fileSize = file.size || file.originFileObj?.size || 0;
            return fileSize / 1024 / 1024 > 2;
        });

        if (oversizedFiles.length > 0) {
            messageApi.error('图片大小不能超过 2MB！');
            setLoading(false);
            return;
        }

        setLoading(true);
        // 发起上传请求
        const res = await uploadFileByBatchByAPI(files);
        setLoading(false);
        return res
    }

    // 打开地图框
    const [isMapModalOpen, setIsMapModalOpen] = useState(false);
    const showMapModal = () => {
        setIsMapModalOpen(true);
    };
    const handleMapOk = () => {
        setIsMapModalOpen(false);
        // 如果有选择的位置，更新表单字段
        if (selectedLocation.lat && selectedLocation.lon) {
            form.setFieldsValue({
                placeLat: selectedLocation.lat,
                placeLot: selectedLocation.lon
            });
        }
    };
    const handleMapCancel = () => {
        setIsMapModalOpen(false);
    };
    const [selectedLocation, setSelectedLocation] = useState({
        lat: center.lat || 0,
        lon: center.lon || 0
    });
    // 处理位置选择（点击地图或搜索）
    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
        // 更新表单中的纬度和经度字段
        form.setFieldsValue({
            placeLat: location.lat,
            placeLot: location.lon
        });
    };

    return (
        <Card
            style={{
                width: '100%',
                minHeight: '100%',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                overflow: 'hidden',
            }}
            title={t('ShowlocationUploadFormList.Title')}
            styles={{
                body: {
                    padding: '0',
                    height: '100%',
                    overflow: 'auto',
                }
            }}
        >
            <Spin spinning={loading} size="large" />
            <div style={{
                width: '100%',
                padding: '20px',
                maxHeight: 'calc(100vh - 120px)',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}>
                {contextHolder}
                <Form
                    {...layout}
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                    style={{
                        width: '100%',
                        maxWidth: '800px',
                        margin: '0 auto',
                        minWidth: '0',
                        boxSizing: 'border-box',
                    }}
                    encType='multipart/form-data'
                    size="large"
                >
                    <Form.Item
                        name="placeName"
                        label={t('ShowlocationUploadFormList.PlaceName')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.PlaceNameMessage'),
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input placeholder={t('ShowlocationUploadFormList.PlaceNameMessage')} />
                    </Form.Item>

                    <Form.Item
                        name="windLevel"
                        label={t('ShowlocationUploadFormList.WindLevel')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.WindLevelMessage'),
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Select
                            options={windLevelCol}
                            placeholder={t('ShowlocationUploadFormList.WindLevelMessage')}
                        />
                    </Form.Item>

                    <Form.Item
                        name="geomagneticDetection"
                        label={t('ShowlocationUploadFormList.GeomagneticDetection')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.GeomagneticDetectionMessage'),
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Select
                            options={GeomagneticDetectionSelection}
                            placeholder={t('ShowlocationUploadFormList.GeomagneticDetectionMessage')}
                        />
                    </Form.Item>

                    <Form.Item
                        name="address"
                        label={t('ShowlocationUploadFormList.Address')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.AddressMessage'),
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input placeholder={t('ShowlocationUploadFormList.AddressMessage')} />
                    </Form.Item>

                    <Form.Item
                        name="city"
                        label={t('ShowlocationUploadFormList.City')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.CityMessage'),
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input placeholder={t('ShowlocationUploadFormList.CityMessage')} />
                    </Form.Item>

                    <Form.Item
                        label={t('ProjectAdditionFormList.PlaceLat')}
                        style={{ marginBottom: '20px' }}
                    >
                        <Space.Compact>
                            <Form.Item
                                name="placeLat"
                                rules={[
                                    {
                                        required: true,
                                        message: `${t('ProjectAdditionFormList.PlaceLatMessage')}`,
                                    },
                                ]}
                                style={{ display: 'inline-block', width: 'calc(100% - 80px)', marginBottom: 0 }}
                            >
                                <Input
                                    placeholder={t('ProjectAdditionFormList.PlaceLatPlaceholder')}
                                    style={{ borderRadius: '6px 0 0 6px' }}
                                />
                            </Form.Item>
                            <Button
                                type="primary"
                                onClick={showMapModal}
                                style={{
                                    borderRadius: '0 6px 6px 0',
                                    width: '80px'
                                }}
                            >
                                {t("ButtonList.Map")}
                            </Button>
                        </Space.Compact>
                    </Form.Item>

                    <Form.Item
                        name="placeLot"
                        label={t('ProjectAdditionFormList.PlaceLot')}
                        rules={[
                            {
                                required: true,
                                message: `${t('ProjectAdditionFormList.PlaceLotMessage')}`,
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input
                            placeholder={t('ProjectAdditionFormList.PlaceLotPlaceholder')}
                            style={{ borderRadius: '6px' }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="uavMin"
                        label={t('ShowlocationUploadFormList.UavMin')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.UavMinMessage'),
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input placeholder={t('ShowlocationUploadFormList.UavMinMessage')} />
                    </Form.Item>

                    <Form.Item
                        name="uavMax"
                        label={t('ShowlocationUploadFormList.UavMax')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.UavMaxMessage'),
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input placeholder={t('ShowlocationUploadFormList.UavMaxMessage')} />
                    </Form.Item>

                    <Form.Item
                        valuePropName="fileList"
                        label={t('ShowlocationUploadFormList.PhotoList')}
                        getValueFromEvent={handleFileChange}
                        rules={[
                            {
                                validator: (_, value) => {
                                    if (!value || value.length === 0) {
                                        return Promise.reject(new Error('请上传至少一张图片'));
                                    }

                                    // 检查文件类型
                                    const invalidFiles = value.filter(file => {
                                        const fileType = file.type || file.originFileObj?.type;
                                        return fileType !== 'image/jpeg' && fileType !== 'image/png';
                                    });

                                    if (invalidFiles.length > 0) {
                                        return Promise.reject(new Error('只能上传 JPG 或 PNG 格式的图片！'));
                                    }

                                    // 检查文件大小
                                    const oversizedFiles = value.filter(file => {
                                        const fileSize = file.size || file.originFileObj?.size || 0;
                                        return fileSize / 1024 / 1024 > 2;
                                    });

                                    if (oversizedFiles.length > 0) {
                                        return Promise.reject(new Error('图片大小不能超过 2MB！'));
                                    }

                                    return Promise.resolve();
                                },
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Upload
                            {...props}
                            listType="picture-card"
                            fileList={fileList}
                            onPreview={handlePreview}
                            onChange={handleChange}
                            beforeUpload={beforeUpload}
                            style={{
                                background: '#fafafa',
                                border: '1px dashed #d9d9d9',
                                borderRadius: '6px',
                            }}
                        >
                            {fileList.length < 3 ? uploadTakeOffAreaButton : null}
                        </Upload>
                        {previewImage && (
                            <Image
                                wrapperStyle={{
                                    display: 'none',
                                }}
                                preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) => setPreviewOpen(visible),
                                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                }}
                                src={previewImage}
                            />
                        )}
                    </Form.Item>

                    <Form.Item
                        name="info"
                        label={t('ShowlocationUploadFormList.Info')}
                        rules={[
                            {
                                required: true,
                                message: '请输入场地信息',
                            },
                        ]}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input.TextArea
                            placeholder="请输入场地详细信息"
                            rows={4}
                            showCount
                            maxLength={500}
                        />
                    </Form.Item>

                    <Form.Item
                        name="visible"
                        label={t('ShowlocationUploadFormList.Visible')}
                        rules={[
                            {
                                required: true,
                                message: t('ShowlocationUploadFormList.VisibleMessage'),
                            },
                        ]}
                        style={{ marginBottom: '32px' }}
                    >
                        <Select
                            placeholder={t('ShowlocationUploadFormList.VisibleMessage')}
                            options={[
                                { value: 0, label: t("ShowlocationUploadFormList.NotVisible") },
                                { value: 1, label: t("ShowlocationUploadFormList.Visible") },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Space size="large" style={{ justifyContent: 'center', width: '100%' }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    border: 'none',
                                    borderRadius: '6px',
                                    padding: '0 40px',
                                    height: '44px',
                                    fontWeight: '500',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                                }}
                            >
                                {t('ButtonList.Submit')}
                            </Button>
                            <Button
                                htmlType="button"
                                onClick={onReset}
                                size="large"
                                style={{
                                    borderRadius: '6px',
                                    padding: '0 40px',
                                    height: '44px',
                                    fontWeight: '500',
                                }}
                            >
                                {t('ButtonList.Reset')}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>

                <Modal
                    title="选择位置"
                    closable={{ 'aria-label': 'Custom Close Button' }}
                    open={isMapModalOpen}
                    onOk={handleMapOk}
                    onCancel={handleMapCancel}
                    width={800}
                    okText="确定选择"
                    cancelText="取消"
                >
                    <MapComponent
                        onLocationSelect={handleLocationSelect} />
                </Modal>

            </div>
        </Card>
    )
}

export default ShowLocationUpload;